import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';

import BasAgentContextMenu from './BasAgentContextMenu';
import BobLoadingMask from '../../../components/BobLoadingMask';
import RenameBasAgentModal from '../Modals/RenameBasAgentModal';
import AssignBasAgentModal from '../Modals/AssignBasAgentModal';
import DeleteBasAgentModal from '../Modals/DeleteBasAgentModal';
import FactoryResetBasAgentModal from '../Modals/FactoryResetBasAgentModal';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import { orderBy } from '@progress/kendo-data-query';

import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './BasAgentView.module.css';

const BasAgentView = ({
    activeNavCompany,
    basAgents,
    bobLoading,
    fetchBasAgents,
    ...props
}) => {

    const [sort, setSort] = useState([]);
    const [agent, setBasAgent] = useState({});
    const [renameAgentModalOpen, setRenameAgentModalOpen] = useState(false);
    const [assignAgentModalOpen, setAssignAgentModalOpen] = useState(false);
    const [deleteAgentModalOpen, setDeleteAgentModalOpen] = useState(false);
    const [factoryResetAgentModalOpen, setFactoryResetAgentModalOpen] = useState(false);

    useEffect(() => {
        const init = async () => {
            await fetchBasAgents(activeNavCompany.id);
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    const actionsCell = props => {
        return (
            <td>
                <BasAgentContextMenu
                    agent={props.dataItem}
                    setBasAgent={setBasAgent}
                    setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                    setFactoryResetAgentModalOpen={setFactoryResetAgentModalOpen}
                    setRenameAgentModalOpen={setRenameAgentModalOpen}
                    setAssignAgentModalOpen={setAssignAgentModalOpen}
                />
            </td>
        );
    };

    const renderStatus = props => {
        const status = props.dataItem.connected;

        if (status === true) {
            return (
                <td>
                    <i className={clsx('far fa-check-circle fa-lg', classes.Connected)} /> Connected
                </td>
            );
        } else if (status === false) {
            return (
                <td>
                    <i className={clsx('far fa-times-circle fa-lg', classes.Disconnected)} /> Disconnected
                </td>
            );
        } else {
            return (
                <td>
                    <i className={clsx('fas fa-minus-circle fa-lg', classes.NotAvailable)} /> Not Available
                </td>
            );
        }
    };

    const renderBasType = props => {
        const basType = props.dataItem.driverConfiguration[0].basType;
        return (
            <td>
                {basType === 'NotConfigured' ? 'Not Configured' : basType}
            </td>
        );
    };

    const renderCurrentLoad = props => {
        const currentLoad = props.dataItem.driverConfiguration[0].currentLoad;
        const formattedCurrentLoad = `${currentLoad.toFixed(2)}%`;
        return (
            <td>
                {formattedCurrentLoad}
            </td>
        );
    };

    const renderSerialNumber = props => {
        const serialNumber = props.dataItem.serialNumber;
        return (
            <td>
                {serialNumber || 'No Agent Assigned'}
            </td>
        );
    };

    const renderFirmware = props => {
        const firmware = props.dataItem.firmwareVersion;
        return (
            <td>
                {firmware || '-'}
            </td>
        );
    };

    return (
        <div className={classes.TableContainer}>
            <div className={classes.Table}>
                <Grid
                    sortable
                    sort={sort}
                    onSortChange={(e) => {
                        setSort(e.sort);
                    }}
                    className={classes.KendoGrid}
                    data={orderBy(basAgents, sort)}
                    total={basAgents.length}
                    reorderable
                >
                    {
                        bobLoading.includes('FetchBasAgents') ?
                            <GridNoRecords>
                                Loading BAS Agents
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column field="name" title="Name" width="auto" />
                    <Column
                        field="connected"
                        title="Status"
                        width="150px"
                        cell={renderStatus}
                    />
                    <Column
                        field="driverConfiguration[0].basType"
                        title="BAS Drivers"
                        width="350px"
                        cell={renderBasType}
                    />
                    <Column
                        field="serialNumber"
                        title="Serial Number"
                        width="auto"
                        cell={renderSerialNumber}
                    />
                    <Column
                        field="firmwareVersion"
                        title="Firmware"
                        width="auto"
                        cell={renderFirmware}
                    />
                    <Column
                        field="driverConfiguration[0].currentLoad"
                        title="BAS Load"
                        width="auto"
                        cell={renderCurrentLoad}
                    />
                    <Column
                        field=""
                        title=""
                        width="auto"
                        cell={actionsCell}
                    />
                </Grid>
            </div>
            {
                factoryResetAgentModalOpen ?
                    <FactoryResetBasAgentModal
                        agent={agent}
                        setFactoryResetAgentModalOpen={setFactoryResetAgentModalOpen}
                    />
                    :
                    null
            }
            {
                deleteAgentModalOpen ?
                    <DeleteBasAgentModal
                        agent={agent}
                        setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                    />
                    :
                    null
            }
            {
                renameAgentModalOpen ?
                    <RenameBasAgentModal
                        agent={agent}
                        setRenameAgentModalOpen={setRenameAgentModalOpen}
                    />
                    :
                    null
            }
            {
                assignAgentModalOpen ?
                    <AssignBasAgentModal
                        agent={agent}
                        setAssignAgentModalOpen={setAssignAgentModalOpen}
                    />
                    :
                    null
            }
            {
                bobLoading.includes('FetchBasAgents') ?
                    <BobLoadingMask />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    bobLoading:       state.bob.bobLoading,
    basAgents:        Object.values(state.basAgent.basAgents)
});

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(BasAgentView);
